/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], () => {

	/**
	 * @interface
	 * @hideconstructor
	 * @classdesc Interface for the FullScreen feature
	 */
	class FullScreenAPI {

		/**
		 * @function FullScreenAPI#enter
		 * @description enter the full-screen mode
		 */
		enter() { }

		/**
		 * @function FullScreenAPI#exit
		 * @description exit the full-screen mode
		 */
		exit() { }

		/**
		 * @function FullScreenAPI#isFullScreen
		 * @description tell if is in the full-screen mode
		 * @returns {boolean} true if is in the full-screen mode, false otherwise
		 */
		isFullScreen() { }
	}

	return FullScreenAPI;
});
